<template>
  <!-- 备案和copyright信息 -->
  <div id="copyright_info">
    <div class="record_all">
      <a
        class="beian"
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602005791"
        style="text-decoration: none"
      >
        <img src="../assets/images/logo/备案图标.png" style="float: left" />
        <p
          style="
            height: 20px;
            line-height: 20px;
            margin: 0px 0px 0px 5px;
            color: #fff;
          "
        >
          沪公网安备 31010602005791号
        </p>
      </a>
      <a
        class="record"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >沪ICP备2020027045号</a
      >
    </div>

    <div class="copyright">
      Copyright 2020 by ShangHai FEIYIN Advertising Limited All rights Reserved
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#copyright_info {
  position: relative;
  width: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  bottom: 29rem;
  z-index: 99999;
  color: white;
  font-size: 0.8125rem;
  opacity: 0.4;
  letter-spacing: 0.0625rem;
}

#copyright_info .record_all .record {
  color: white;
  text-decoration: none;
  margin-left: 1.5rem;
}

#copyright_info .record_all {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin-left: 1rem;
}
.copyright {
  margin-right: 1rem;
}
</style>
